import { isPlainTextPricelistFile } from '@erp/shared-utils';
import type { PricelistCaseFileDTO } from '@erp/rpc';

export type PricelistCaseFilePreviewKind =
  'pending' | 'source-table' | 'source-text' | 'csv';

export function pricelistCaseFilePreviewKind(
  file: Pick<PricelistCaseFileDTO, 'name' | 'role'>,
  csvDocumentId: string | undefined,
  isPricelistPending: boolean,
): PricelistCaseFilePreviewKind {
  if (isPricelistPending) return 'pending';
  if (!isPlainTextPricelistFile(file.name)) return 'csv';
  if (file.role !== 'price_file') return 'source-text';
  if (csvDocumentId === undefined) return 'source-table';
  return 'csv';
}
